  // Add to cart feedback
  document.querySelectorAll('.add-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const orig = btn.textContent;
      btn.textContent = 'Added ✓';
      btn.style.background = 'var(--teal)';
      btn.style.borderColor = 'var(--teal)';
      btn.style.color = 'var(--ink)';
      setTimeout(() => {
        btn.textContent = orig;
        btn.style.background = '';
        btn.style.borderColor = '';
        btn.style.color = '';
      }, 1600);
    });
  });

  // ════════ Out-of-stock "another castle" screen ════════
  (function(){
    var screen = document.getElementById('oos-screen');
    if(!screen) return;
    var consoleEl = document.getElementById('oos-console');
    var items = Array.prototype.slice.call(screen.querySelectorAll('.oos-menu a'));
    var lastFocus = null, idx = 0;

    function setSel(n){
      idx = (n + items.length) % items.length;
      items.forEach(function(a,k){ a.classList.toggle('sel', k===idx); });
    }
    function open(name){
      if(name && consoleEl) consoleEl.textContent = name;
      lastFocus = document.activeElement;
      screen.classList.add('open');
      screen.setAttribute('aria-hidden','false');
      document.body.classList.add('oos-lock');
      setSel(0);
      if(items[0]) items[0].focus({preventScroll:true});
    }
    function close(){
      screen.classList.remove('open');
      screen.setAttribute('aria-hidden','true');
      document.body.classList.remove('oos-lock');
      if(lastFocus && lastFocus.focus) lastFocus.focus({preventScroll:true});
    }
    window.showOutOfStock = open;   // public hook: showOutOfStock('SNES')

    document.querySelectorAll('[data-soldout]').forEach(function(el){
      el.addEventListener('click', function(e){
        e.preventDefault();
        open(el.getAttribute('data-soldout') || 'THIS CONSOLE');
      });
    });

    items.forEach(function(a,k){
      a.addEventListener('mouseenter', function(){ setSel(k); });
      a.addEventListener('click', function(){ close(); });
    });

    var back = screen.querySelector('.oos-back');
    if(back) back.addEventListener('click', function(e){ e.preventDefault(); close(); });

    document.addEventListener('keydown', function(e){
      if(!screen.classList.contains('open')) return;
      if(e.key === 'Escape'){ close(); }
      else if(e.key === 'ArrowDown'){ e.preventDefault(); setSel(idx+1); items[idx].focus({preventScroll:true}); }
      else if(e.key === 'ArrowUp'){ e.preventDefault(); setSel(idx-1); items[idx].focus({preventScroll:true}); }
      else if(e.key === 'Enter' && document.activeElement.tagName !== 'A'){ items[idx].click(); }
    });
  })();

